import { getContentTypeResponse } from '@/lib/util';
import baseApi from './base';
import config from '@/lib/config/index';
import { BreatheVocamVideoLinkTag } from './tags';
import { ResourceSignature } from '@/modules/types/resource';

const API_PREFIX = config.api.enableBFF ? '/api' : '';
const ANON_BASE_URL = `${config.api.baseUrl}${API_PREFIX}/anon/v1/`;

export interface BreatheLaunchParam {
  tenantId: string;
  elearningId: string;
  breatheToken: string;
}

export interface BreatheLaunchData {
  tenantId: string;
  elearningId: string;
  identifier: string;
  uid: string;
  mid: string;
  cid: string;
  // Optional: absent on API builds that predate LMS2-5136 (deploy-order safe);
  // resource links then stay unsigned, i.e. today's behaviour.
  resourceSignature?: ResourceSignature;
}

export interface BreatheCompleteParam {
  tenantId: string;
  elearningId: string;
  breatheToken: string;
  uid: string;
  mid: string;
  cid: string;
  score: number;
  responseDetails: Record<string, unknown>;
}

export interface BreatheCompleteData {
  message: string;
}

const breatheApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBreatheLaunch: build.query<BreatheLaunchData, BreatheLaunchParam>({
      query: ({ tenantId, elearningId, breatheToken }) => ({
        url: `${ANON_BASE_URL}breathe/${tenantId}/${elearningId}/launch`,
        params: { bt: breatheToken },
      }),
    }),
    submitBreatheCompletion: build.mutation<
      BreatheCompleteData,
      BreatheCompleteParam
    >({
      query: ({ tenantId, elearningId, breatheToken, ...body }) => ({
        url: `${ANON_BASE_URL}breathe/${tenantId}/${elearningId}/complete`,
        method: 'POST',
        body: { ...body, bt: breatheToken },
      }),
    }),
    getBreatheVocamVideoLink: build.query<
      string,
      {
        breatheToken: string;
        tenantId: string;
        moduleId: number;
        topicId: number;
      }
    >({
      query: (param) => ({
        url: `${ANON_BASE_URL}breathe/vocam-video-link/${param.tenantId}/${param.moduleId}/${param.topicId}`,
        params: { bt: param.breatheToken },
        responseHandler: getContentTypeResponse,
      }),
      providesTags: [BreatheVocamVideoLinkTag],
    }),
  }),
  overrideExisting: false,
});

export default breatheApi;
